import styled from '@emotion/styled';

import { ButtonWithLoading } from 'components/buttons/buttonWithLoading';
import { InputRoot } from 'components/inputs/input/styles';

export const Section = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: 8,
  // @ts-ignore
  [InputRoot]: {
    width: 290,
  },
}));

export const SelectContainer = styled.div((props) => ({
  width: 290,
}));

export const Label = styled.span((props) => ({
  display: 'flex',
  gap: 15,
  fontSize: 13,
  lineHeight: '16px',
  fontWeight: 400,
  fontFamily: props.theme.fonts.primary,
}));

export const LightText = styled.span((props) => ({
  fontSize: 13,
  lineHeight: '16px',
  fontWeight: 400,
  fontFamily: props.theme.fonts.primary,
  color: props.theme.colors.inactive,
  fontStyle: 'italic',
}));

export const Delimeter = styled.div((props) => ({
  borderBottom: `1px solid ${props.theme.colors.container.primary}`,
  width: '100%',
}));

export const Description = styled.div((props) => ({
  color: props.theme.colors.text.secondary,
  fontSize: 13,
  lineHeight: '16px',
  fontWeight: 400,
  fontFamily: props.theme.fonts.primary,
  margin: '20px 0',
  textAlign: 'center',
  width: '100%',
}));

export const SecondaryText = styled.span(({ theme }) => ({
  fontSize: 13,
  fontWeight: 400,
  fontFamily: theme.fonts.primary,
  color: theme.colors.inactive,
}));

export const ThinModalButton = styled(ButtonWithLoading)(() => ({
  width: 'unset !important',
  flexShrink: 0,
  height: '25px !important',
  marginTop: -2.5,
}));
